import styled from 'styled-components'

export const StudioWrapper = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  background: #f5f5f5;
`

export const ChatSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-right: 1px solid #e0e0e0;
  min-width: 0;
`

export const TracesSection = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
`

export const ChatHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  span {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
    display: block;
  }
`

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Message = styled.div<{ sender: 'user' | 'assistant' }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.sender === 'user' ? 'flex-end' : 'flex-start'};

  .message-content {
    max-width: 70%;
    padding: 12px 16px;
    border-radius: 12px;
    background: ${(props) => (props.sender === 'user' ? '#1976d2' : '#f0f0f0')};
    color: ${(props) => (props.sender === 'user' ? 'white' : '#333')};
    font-size: 14px;
    line-height: 1.5;

    .trace-link {
      margin-top: 8px;

      a {
        color: ${(props) => (props.sender === 'user' ? '#b3d7ff' : '#1976d2')};
        text-decoration: none;
        font-size: 12px;
        display: inline-flex;
        align-items: center;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .message-time {
    font-size: 11px;
    color: #999;
    margin-top: 4px;
    padding: 0 4px;
  }
`

export const ChatInputWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
  align-items: center;

  input {
    font-size: 14px;
  }

  button {
    min-width: 80px;
  }
`

export const DatasourcesBar = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;

  h4 {
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  .datasources-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const DatasourceChip = styled.div<{ connected?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: ${(props) => (props.connected ? '#e8f5e9' : '#f5f5f5')};
  border-radius: 16px;
  font-size: 12px;
  color: #333;
  border: 1px solid ${(props) => (props.connected ? '#c8e6c9' : '#e0e0e0')};

  .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props) => (props.connected ? '#4caf50' : '#999')};
    margin-right: 6px;
  }
`

export const TracesHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
`

export const TracesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TraceItem = styled.div<{ status: string }>`
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f0f0f0;
    border-color: #d0d0d0;
  }

  .trace-header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 8px;

    h4 {
      margin: 0;
      font-size: 13px;
      font-weight: 600;
      color: #333;
      flex: 1;
      margin-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .status {
      font-size: 11px;
      padding: 2px 8px;
      border-radius: 12px;
      text-transform: uppercase;
      font-weight: 600;
      flex-shrink: 0;

      &.completed {
        background: #e8f5e9;
        color: #2e7d32;
      }

      &.running {
        background: #fff3e0;
        color: #f57c00;
      }

      &.error {
        background: #ffebee;
        color: #c62828;
      }
    }
  }

  .trace-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    color: #666;
    margin-bottom: 8px;
  }

  .trace-stats {
    display: flex;
    gap: 16px;
    font-size: 11px;
    color: #999;

    span {
      display: flex;
      align-items: center;

      &:before {
        content: '•';
        margin-right: 4px;
      }

      &:first-child:before {
        display: none;
      }
    }
  }
`

export const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;

  .typing-indicator {
    display: flex;
    gap: 4px;

    span {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #999;
      animation: typing 1.4s ease-in-out infinite;

      &:nth-child(2) {
        animation-delay: 0.2s;
      }

      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }

  @keyframes typing {
    0%,
    60%,
    100% {
      opacity: 0.3;
      transform: translateY(0);
    }
    30% {
      opacity: 1;
      transform: translateY(-10px);
    }
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;

  p {
    margin: 0 0 8px 0;
    font-size: 14px;
    font-weight: 500;
  }

  span {
    font-size: 12px;
  }
`
